var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',_vm._b({ref:"rankAltTable"},'vxe-grid',_vm.vxeOption,false))}
var staticRenderFns = []

export { render, staticRenderFns }